import React, { useState, useRef, useEffect } from 'react';
import { connect } from 'react-redux';

import PropTypes from 'prop-types';

import amplitude from 'amplitude-js';
import { toggleSpinner } from 'apps/auth/actions/appAction';
import { toggleChat } from 'apps/auth/actions/chatAction';
import PopupButton from 'apps/auth/components/common/Popup/PopupButton';
import SimplePopup from 'apps/auth/components/common/Popup/SimplePopup';
import { getHelpMobileIdParams } from 'apps/auth/components/utils/AmplitudeUtils';
import { DID_NOT_GET_CODE_RESEND_CLICKED, DID_NOT_GET_CODE_SCREEN_SHOWN, GET_HELP_CLICKED } from 'apps/auth/constants/amplitude/AmplitudeEvents';
import { COUNTRY_OF_RESIDENCE } from 'apps/auth/constants/amplitude/AmplitudeParamName';
import { HELP_MOBILE } from 'apps/auth/constants/UrlConstants';
import { getLangCountryPrefix } from 'apps/auth/helpers/utils';
import { useApp, useExtra, useLanguage, usePageMessages } from 'apps/auth/hooks/selectors';
import { useThemeDetector } from 'apps/auth/hooks/theme';
import { MarkdownService } from 'apps/auth/services/MarkdownService';

const ResendCodePopup = (props) => {
    const resetInterval = useRef();
    const [resentTime, setResetTime] = useState(props.resentTime);
    const [showResend, setShowResend] = useState(props.showResend);
    const { faqUrl } = useExtra();
    const { theme } = useThemeDetector();
    const { country } = useApp();
    const { lang } = useLanguage();
    const messages = usePageMessages();

    useEffect(() => {
        sendEvent(DID_NOT_GET_CODE_SCREEN_SHOWN);
    }, []);

    useEffect(() => {
        resetInterval.current = props.resetInterval.current;
        const tick = () => {
            if (props.resetInterval.current > 0) {
                resetInterval.current -= 1;
                props.calculateTime(resetInterval.current, setResetTime);
            } else {
                setShowResend(true);
                const newTime = props.resetInterval || props.interval;
                props.calculateTime(newTime, setResetTime);
            }
        };

        const id = setInterval(tick, 1000);
        return () => clearInterval(id);
    }, [props.resetInterval.current]);

    const sendEvent = (eventName) => {
        amplitude.getInstance().logEvent(eventName, {
            [COUNTRY_OF_RESIDENCE]: props.country?.nameEn,
        });
    };

    return (
        <SimplePopup popupRef={props.popupRef} text={MarkdownService.splitByParagraph(props.text)}>
            {!props.declineResendSms && !props.isExceedLimitsError && (
                <PopupButton
                    iconName="retry"
                    text={showResend ? props.smsResendBtn : props.smsResendText || `${props.smsResendTitle} ${resentTime}`}
                    onClick={(e) => {
                        sendEvent(DID_NOT_GET_CODE_RESEND_CLICKED);
                        if (showResend) {
                            props.popupRef.current?.close();
                            props.resendClick(e);
                        }
                    }}
                    disabled={!showResend}
                />
            )}
            <PopupButton
                text={messages.morePopupGetHelpButton}
                iconName="lifebuoy"
                href={`${getLangCountryPrefix(lang, country)}${HELP_MOBILE}${faqUrl || ''}?mode=${theme}&anonymousChat=true`}
                onClick={() => {
                    props.toggleSpinner(true);
                    props.popupRef.current?.close();
                    amplitude.getInstance().logEvent(GET_HELP_CLICKED, getHelpMobileIdParams(faqUrl));
                }}
            />
        </SimplePopup>
    );
};

ResendCodePopup.propTypes = {
    popupRef: PropTypes.shape({ current: PropTypes.object }).isRequired,
    resetInterval: PropTypes.object.isRequired,
    text: PropTypes.string,
    smsResendText: PropTypes.string,
    smsResendTitle: PropTypes.string,
    smsResendBtn: PropTypes.string,
    contactSupport: PropTypes.string,
    resendClick: PropTypes.func,
    declineResendSms: PropTypes.bool,
    isExceedLimitsError: PropTypes.bool,
    showResend: PropTypes.bool,
    resentTime: PropTypes.string,
    calculateTime: PropTypes.func,
    toggleSpinner: PropTypes.func,
};

export default connect(null, { toggleChat, toggleSpinner })(ResendCodePopup);
